import Grid from "@components/Grid/Grid";
import clsx from "clsx";
import AccordionContainer, { AccordionData } from "./AccordionContainer";
import styles from "./C11_VerticalAccordion.module.scss";

interface VerticalAccordionProps {
  accordions: AccordionData[];
  backgroundColor?: "grey" | "white" | "dark-blue";
  isSmall?: boolean;
  customClass?: string;
  title?: string;
}

const VerticalAccordion = (props: { content: VerticalAccordionProps }) => {
  const { accordions, backgroundColor, isSmall, customClass, title } =
    props.content;

  const requiresTitlePlaceholder =
    (accordions?.filter(
      (accordion) => (accordion.fields.title?.trim() ?? "") !== ""
    ).length ?? 0) === 1;

  return (
    <>
      {isSmall ? (
        <AccordionContainer accordionFields={accordions[0].fields} />
      ) : (
        <div className={clsx("outer-wrap", backgroundColor, customClass)}>
          {title?.trim() && (
            <div className="wrapper">
              <h2 className={styles["title"]}>{title}</h2>
            </div>
          )}
          <div className="wrapper">
            {accordions?.length > 0 && (
              <Grid row>
                {accordions.map((item, index) => (
                  <Grid
                    column
                    sm={12}
                    md={accordions.length === 2 ? 6 : 12}
                    key={`vertical-accordion-${index}`}
                  >
                    <AccordionContainer
                      requiresTitlePlaceholder={requiresTitlePlaceholder}
                      accordionFields={item.fields}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default VerticalAccordion;
